import LessonDetailsPage from "../../components/courses/details/[id]/lesson/[lesson_id]/LessonDetailsPage";

const LessonDetails = () => {
    return <LessonDetailsPage />;
  };
  export default LessonDetails;
  